/** @jsxImportSource @emotion/react */

import { Radio, RadioChangeEvent } from "antd";
import { ReactComponent as KeyIcon } from "assets/common/icons/key.svg";
import { ReactComponent as LockWithdrawIcon } from "assets/common/icons/lock-solid.svg";
import { ReactComponent as PhoneIcon } from "assets/common/icons/phone.svg";
import HelmetCustom from "components/common/HelmetCustom";
import MDrawer from "components/mobile/MDrawer";
import { PATH, userPath } from "constants/path";
import { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { MSecuritySettingPageStyle } from "./index.style";
import MChangePassword from "./MChangePassword";
import MPhoneNumberCard from "./MPhoneNumberCard";

enum SecuritySettingValue {
  CHANGE_PASSWORD = "change-password",
  UPDATE_PROFILE = "update-profile",
  CHANGE_PASSWORD_WITHDRAW = "change-password-withdraw",
  PHONE_NUMBER = "phone-number",
}

const SECURITY_SETTING_OPTIONS = [
  {
    label: "Sửa đổi mật khẩu",
    value: SecuritySettingValue.CHANGE_PASSWORD,
    icon: <KeyIcon />,
  },
  {
    label: "Đổi mật khẩu rút tiền",
    value: SecuritySettingValue.CHANGE_PASSWORD_WITHDRAW,
    icon: <LockWithdrawIcon height={20} width={20} />,
  },
  // {
  //   label: "Hồ sơ",
  //   value: SecuritySettingValue.UPDATE_PROFILE,
  //   icon: <UserIcon />,
  // },
  {
    label: "Số điện thoại",
    value: SecuritySettingValue.PHONE_NUMBER,
    icon: <PhoneIcon width={15} height={23} />,
  },
];

const MSecuritySettingPage = () => {
  const navigate = useNavigate();

  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const valueSetting = useMemo(() => {
    return searchParams.get("option");
  }, [searchParams]);

  const onChange = (e: RadioChangeEvent) => {
    if (e.target.value === SecuritySettingValue.CHANGE_PASSWORD_WITHDRAW) {
      navigate(PATH.User.changePasswordWithdraw);
      return;
    }
    setSearchParams({
      option: e.target.value,
    });
  };

  const handleClose = () => {
    setIsOpenDraw(false);
    navigate(userPath);
  };

  const cancelSelected = () => {
    setSearchParams();
  };

  const genarateTitleDrawer = (): string => {
    switch (valueSetting) {
      case SecuritySettingValue.CHANGE_PASSWORD:
        return "Thay đổi mật khẩu";
      // case SecuritySettingValue.UPDATE_PROFILE:
      //   return "Thay đổi thông tin";
      case SecuritySettingValue.PHONE_NUMBER:
        return "Số điện thoại";
      default:
        return "Bảo mật";
    }
  };

  return (
    <div css={MSecuritySettingPageStyle.self}>
      <HelmetCustom title="Security" />
      <MDrawer
        title={genarateTitleDrawer()}
        isOpen={isOpenDraw}
        onClose={handleClose}
        isBack={valueSetting ? true : false}
        onBack={() =>
          setSearchParams({
            option: "",
          })
        }
      >
        <Radio.Group
          css={MSecuritySettingPageStyle.optionList}
          onChange={onChange}
          value={valueSetting}
        >
          {!valueSetting &&
            SECURITY_SETTING_OPTIONS.map((item, index) => (
              <Radio.Button
                key={index}
                value={item.value}
                css={MSecuritySettingPageStyle.optionItemWrapper}
              >
                <div css={MSecuritySettingPageStyle.optionItem}>
                  {item.icon}
                  <h4>{item.label}</h4>
                </div>
              </Radio.Button>
            ))}
        </Radio.Group>

        {valueSetting === SecuritySettingValue.CHANGE_PASSWORD && (
          <MChangePassword onCancel={cancelSelected} />
        )}

        {/* {valueSetting === SecuritySettingValue.UPDATE_PROFILE && (
          <MUpdateProfile onCancel={cancelSelected} />
        )} */}

        {valueSetting === SecuritySettingValue.PHONE_NUMBER && (
          <MPhoneNumberCard />
        )}
      </MDrawer>
    </div>
  );
};

export default MSecuritySettingPage;
